import { createTheme } from '@mui/material';

export let theme = createTheme({
  root: {
    padding: { xl: '0 192px', md: '0 64px' },
  },
  background: {
    default: 'rgb(249, 249, 249)',
  },
  palette: {
    type: 'light',
    primary: {
      main: '#80BB57',
      black: '#212121',
      white: '#FFF',
    },
    secondary: {
      black: '#3D3D3D',
      main: '#2A7FEF',
      greenMedium: '#81bc56',
      mainGray: '#6c757d',
      mediumGray: '#C4C4C4',
      lightGray: '#e0e0e0',
    },
    error: {
      main: '#FF4238',
      mediumError: '#d32f2f',
    },
    success: {
      main: '#15C15D',
    },
    warning: {
      main: '#ffeb3b',
    },
  },
  button: {
    bgColorGray: 'rgba(36, 35, 35, 0.3)',
    bgColorGrayHover: 'rgba(36, 35, 35, 0.4)',
    bgHoverBtn: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
    boxShadowBtnHover: '0 6px 10px rgba(102, 126, 234, 0.4)',
    boxShadowBtn: '0 5px 10px 0px rgba(77, 84, 117, 0.3)',
    boxShadowHover: '0 12px 40px rgba(0, 0, 0, 0.12)'
  },
  cards: {
    bgCards: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    iconBackground: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
    borderCards: '1px solid rgba(0, 0, 0, 0.06)',
    borderHoverCards: '1px solid rgba(102, 126, 234, 0.2)',
  },
  payroll: {
    greenMain: '#00A58E',
    greenLight: '#ECF8F7',
  },
  typography: {
    h1: {
      fontFamily: 'Nunito',
      fontWeight: 700,
      fontSize: '4.8rem',
    },
    h2: {
      fontFamily: 'Nunito',
      fontSize: '2.8rem',
      fontWeight: 600,
    },
    fontFamily: 'Nunito',
    fontSize: 16,
    fontWeightLight: 300,
    body1: {
      fontSize: '2.4rem',
      lineHeight: 1.25,
    },
    h4: {
      fontSize: '2rem',
      fontWeight: 700,
    },
    h5: {
      fontWeight: 700,
      fontSize: '2.2rem',
    },
    h3: {
      fontSize: '2.2rem',
    },
    h6: {
      fontSize: '1.3rem',
      fontWeight: 400,
    },
  },
  shape: {
    borderRadius: 4,
  },
  props: {
    MuiAppBar: {
      color: 'inherit',
    },
  },
  focused: {},
  disabled: {},
  error: {},
  overrides: {
    MuiAlert: {
      standardInfo: {
        backgroundColor: 'transparent',
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #484646',
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: '1px solid #484646',
        },
        '&:focused:after': {
          borderBottom: '1px solid #484646',
        },
      },
    },
    MuiAppBar: {
      colorInherit: {
        backgroundColor: '#FFF',
        color: '#000',
      },
    },
  },
});

theme.components.MuiToolbar = {
  [theme.breakpoints.down('md')]: { alignItems: 'space-evenly' },
};

theme.typography.h2 = {
  [theme.breakpoints.down('lg')]: { fontSize: '22px' },
};
